import useMods from '@hooks/useMods';
import PropTypes from 'prop-types';
import React from 'react';

const BreadcrumbsWrap = ({ children }) => {
    const { className } = useMods(BreadcrumbsWrap);

    return (
        <nav
            className={ className }
        >
            { children }
        </nav>
    );
};

BreadcrumbsWrap.displayName = 'Breadcrumbs-Wrap';

BreadcrumbsWrap.propTypes = {
    children: PropTypes.node
};

export default BreadcrumbsWrap;
